import React, { useState, useEffect } from 'react';
import './DKBanner.css';
import NorthEastIcon from '@mui/icons-material/NorthEast';
import DKPopup from '../dkPopup/DKPopup';
import { $authHost } from 'app/configs/axiosConfig';

interface Banner {
  id: number;
  message: string | null;
  userId: number;
  email: string | null;
  viewedPopup: boolean;
  submittedMessage: boolean;
  timestamp: Date;
}

const DKBanner: React.FC = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [bannerData, setBannerData] = useState<{ data: Banner } | null>(null);

  useEffect(() => {
    $authHost
      .get('/banner')
      .then((response) => {
        setBannerData(response.data);
      })
      .catch((error) => {
        console.error('Error fetching banner data:', error);
      });
  }, []);

  const handleBannerClick = () => {
    setIsPopupOpen(true);
  };

  const closePopup = (submitted: boolean) => {
    setIsPopupOpen(false);
    if (submitted) {
      $authHost
        .get('/banner')
        .then((response) => {
          setBannerData(response.data);
        })
        .catch((error) => {
          console.error('Error fetching banner data:', error);
        });
    }
  };

  return (
    <div>
      {bannerData && !bannerData.data.submittedMessage && (
        <div
          className="dk-banner text-white p-16 rounded-[12px] mb-4 flex flex-col items-start justify-between mx-24 cursor-pointer"
          onClick={handleBannerClick}
        >
          <img src="/assets/images/logo/logo_dk_sm.svg" alt="DK Logo" />
          <div className="flex flex-col items-start mt-16">
            <div className="text-lg leading-[22.4px] mb-2 font-500">
              Exclusive Offer: <br />
              Get $500 Off Web Design and Web Development!
            </div>
            <button className="banner-button font-semibold bg-white/20 mt-24 text-white border border-white px-[15px] py-10 rounded-md gap-10 cursor-pointer transition-colors text-[16px] duration-300 flex items-center hover:bg-white/40">
              Boost your sales
              <NorthEastIcon className="w-20 h-20" />
            </button>
          </div>
        </div>
      )}

      {isPopupOpen && (
        <DKPopup handleClose={closePopup} open={isPopupOpen} bannerData={bannerData} />
      )}
    </div>
  );
};

export default DKBanner;
